<template>
    <div class="page-footer-block" :class="[isFFF?'bg-FFF':'']">
        <el-row type="flex" style="border-bottom: 1px solid #DFDFDF">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="6">&nbsp;</el-col>
            <el-col :xs="22" :sm="22" :md="20" :lg="16" :xl="12">
                <div class="block-content up" v-show="channelWidth>768">
                    <div class="route-info">
                        <div class="title">产品介绍</div>
                        <div class="list">
                            <div class="list-item" v-for="(item,index) in productsList" :data-index="index" data-type="productsList" @click="routerTo">
                                {{item.name}}
                            </div>
                        </div>
                    </div>
                    <div class="route-info">
                        <div class="title">解决方案</div>
                        <div class="list-block">
                            <div class="list">
                                <div class="list-item" v-for="(item,index) in solutionOneList" :data-index="index" :data-path="item.path" data-type="solutionOneList" @click="routerTo">
                                    {{item.name}}
                                </div>
                            </div>
                            <div class="list">
                                <div class="list-item" v-for="(item,index) in solutionTwoList" :data-index="index" :data-path="item.path" data-type="solutionTwoList" @click="routerTo">
                                    {{item.name}}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="route-info">
                        <div class="title">联系方式</div>
                        <div class="info">
                            <img :src="addressIcon"/>
                            <div>地址：江苏省南京市雨花台区紫悦广场东大楼01幢401室</div>
                        </div>
                        <div class="info">
                            <img :src="telIcon"/>
                            <div>电话：400-8128-908</div>
                        </div>
                        <div class="info">
                            <img :src="eMailIcon"/>
                            <div>邮箱：chenyun@njysnet.com</div>
                        </div>
                    </div>
                    <div class="weChat">
                        <div>
                            <img :src="weChatIcon"/>
                        </div>
                        <div>
                            <img :src="codeImage"/>
                        </div>

                    </div>
                </div>
                <div class="down-content" v-show="channelWidth<=768">
                    <div class="down-info">
                        <div class="down-title">联系方式</div>
                        <div class="down-row">
                            <div class="row-info">
                                <img :src="telIcon"/>
                                <div>电话：400-8128-908</div>
                            </div>
                            <div class="we-chat" @click="showCodeChange">
                                <img style="width: 15px;height: 13px;margin-top: 0" :src="weChatIcon"/>
                                <div>微信</div>
                            </div>
                        </div>
                        <div class="row-info">
                            <img :src="eMailIcon"/>
                            <div>邮箱：chenyun@njysnet.com</div>
                        </div>
                        <div class="row-info" style="margin-bottom: 0">
                            <img :src="addressIcon"/>
                            <div>地址：江苏省南京市雨花台区紫悦广场东大楼01幢401室</div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="6">&nbsp;</el-col>
        </el-row>
        <el-row type="flex">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="8">&nbsp;</el-col>
            <el-col :xs="22" :sm="22" :md="20" :lg="16" :xl="8">
                <div class="block-content down">
                    <div class="content">
                        <div>版权所有 © 2018-2025</div>|
                        <div class="middle">江苏劲步科技有限公司</div>|
                        <div>苏ICP备19018934号-3</div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="8">&nbsp;</el-col>
        </el-row>
        <div class="mark" v-show="showCode" @click="showCodeChange">
            <div class="code">
                <img :src="codeImage"/>
            </div>
        </div>
    </div>
</template>

<script>
    import EMailIcon from '../../views/image/e_mail_icon.png'
    import AddressIcon from '../../views/image/address.png'
    import WeChatIcon from '../../views/image/we_chat_icon.png'
    import TelIcon from '../../views/image/tel_icon.png'
    import CodeImage from '../../views/image/common/code_img.jpg'
    export default {
        name: "page-footer-block",
        data(){
            return{
                eMailIcon:EMailIcon,
                addressIcon:AddressIcon,
                weChatIcon:WeChatIcon,
                codeImage:CodeImage,
                telIcon:TelIcon,
                channelWidth: null,      //浏览器窗口宽度
                productsList:[
                    {name:'网关系列',pathValue:'0'},
                    {name:'传感器系列',pathValue:'1'},
                    {name:'摄像头系列',pathValue:'2'},
                    {name:'设备监控中心',pathValue:'3'},
                ],
                solutionOneList:[
                    {name:'校园解决方案',path:'/page/solution/school'},
                    {name:'环保解决方案',path:'/page/solution/environment'},
                    {name:'化工解决方案',path:'/page/solution/chemical-industry'},
                    {name:'工地解决方案',path:'/page/solution/construction'},
                ],
                solutionTwoList:[
                    {name:'城管解决方案',path:'/page/solution/administration'},
                    {name:'农业解决方案',path:'/page/solution/agriculture'},
                ],
                isFFF:false,     //判断背景是否为白色
                showCode:false
            }
        },
        watch:{
            /**
             * 浏览器宽度变化赋值
             * @param newVal
             */
            '$store.state.screenWidth'(newVal){
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                if (!this.timer) {
                    // 一旦监听到的productWidth值改变，就将其重新赋给data里的channelWidth.
                    this.channelWidth = newVal
                    this.timer = true;
                    setTimeout(() => {
                        // console.log(this.channelWidth);
                        this.timer = false;
                    }, 400);
                }
            },
            /**
             * 路由监听判断背景色
             */
            $route(to,from){
                let path = to.path,
                    list = ['/page/products','/page/solution/school'],
                    index = list.findIndex(item =>{
                        return item == path
                    });
                if(index != -1){
                    this.isFFF = true
                }else{
                    this.isFFF = false
                }
            }
        },
        mounted(){
            //获取浏览器宽度
            this.channelWidth = this.$store.state.screenWidth;
        },
        methods:{
            /**
             * 路由跳转
             * @param e
             */
            routerTo(e){
                let index = e.currentTarget.dataset.index,
                    type = e.currentTarget.dataset.type,
                    list = this[type];
                if(type ==='productsList'){     //产品相关页面
                    this.$router.push({name:'products',params:{typeIndex:list[index].pathValue}});
                }else{
                    let path = e.currentTarget.dataset.path;
                    this.$router.push(path);
                }
            },
            /**
             * 二维码展示
             */
            showCodeChange(){
                this.showCode = !this.showCode
            }
        }
    }
</script>

<style lang="scss" src="./index.scss" scoped></style>
<style lang="scss" src="./index-mini.scss" scoped></style>
